import React, { useEffect, useState } from "react";

import { ToastContainer } from "react-bootstrap";
import StatusToast from "./StatusToast";
import { StatusToastType, StatusToastContainerType } from "./types";
import { TOAST_EXPIRATION, TOAST_SHOW_DURATION } from "../../common/constants";
import { clearStatusToasts } from "./StatusToastSlice";
import { useAppDispatch } from "../../app/hooks";

const StatusToastContainer = ({ Toasts }: StatusToastContainerType) => {
  const generateKey = (pre: string, index: number) => {
    const formattedPre = encodeURIComponent(pre.substring(0, 20));
    return `${formattedPre}_${index}`;
  };
  const dispatch = useAppDispatch();
  const [toastItems, setToastItems] = useState<StatusToastType[]>([]);

  // Force clearing of StatusContainer HTML after time threshold
  useEffect(() => {
    setToastItems(Toasts);
    // Dispatch the action to clear the toasts from Redux after they are displayed
    if (Toasts.length > 0) {
      const expiration = Math.max(
        ...Toasts.map((t) =>
          t.IsFailed ? 2 * TOAST_EXPIRATION : TOAST_EXPIRATION,
        ), // per-toast lifetime
      );
      setTimeout(() => {
        setToastItems([]); // Clears from local state
        dispatch(clearStatusToasts()); // Clears from Redux state
      }, expiration);
    }
  }, [Toasts, dispatch]);

  return (
    <ToastContainer className="position-fixed p-24" position="bottom-end">
      {toastItems != null &&
        toastItems.length > 0 &&
        toastItems.map((toast, index) => (
          <StatusToast
            key={generateKey(toast.Message, index)}
            IsFailed={toast.IsFailed}
            Message={toast.Message}
            Timestamp={toast.Timestamp}
            Title={toast.Title}
          />
        ))}
    </ToastContainer>
  );
};

export default StatusToastContainer;
export { StatusToastContainer };
